import React from "react";
import ReactDOM from "react-dom";
import "tachyons";
import "./index.css";
import App from "./App";
import State from "./context/state";
import { BrowserRouter as Router } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    dsn: "https://64c383e706664db5977802f219f8c606@o1367173.ingest.sentry.io/6667738",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.25
  });
  Sentry.setUser({ id: localStorage.getItem('outlet_uuid') })
  Sentry.setExtras({
    user_uuid: localStorage.getItem('user_uuid'),
    user_type: localStorage.getItem('user_type'),
    outlet_name: localStorage.getItem('outlet-name'),
  })
}

window.addEventListener('unload', (event) => {
  sessionStorage.removeItem("_FIREBASE_CALLBACKS_SET");
});

document.addEventListener("wheel", function (event) {
  if (document.activeElement.type === "number") {
    document.activeElement.blur();
  }
});

// const FallbackUI = () => {
//   const p = window.location.pathname
//   const isDashboard = p?.includes('/page') || p?.includes('/orders')
//   return <div className="crash-page-container">
//     <div>
//       <p>Something went wrong,</p>
//       {window.location.hostname !== 'localhost' ? (
//         navigator.onLine ? <>
//           <p>Our development team has been notified about this issue</p>
//           <p className="small-text">We urge you to have some patience, It'll be resolved soon.</p>
//         </> : <>
//           <p>Please turn on your internet connection to send <i>error details</i> to our team.</p>
//           <p className="small-text">Your issues are our top-most priority, It'll be resolved soon.</p>
//         </>
//       ) : <>
//         <p>Development errors are never sent to Sentry.io</p>
//         <p className="small-text">Application is running on development server</p>
//       </>
//       }
//     </div>
//     <button onClick={e => {
//       e.target.innerText = "..."
//       if (isDashboard) window.location.reload()
//       else window.location.pathname = '/page1'
//     }}>{isDashboard ? 'Reload' : 'Dashboard'}</button>
//   </div >
// }

ReactDOM.render(
  // <Sentry.ErrorBoundary fallback={<FallbackUI />}>
  <Sentry.ErrorBoundary>
    <State>
      <Router>
        <App />
      </Router>
    </State>
  </Sentry.ErrorBoundary>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();